import i18next from 'i18next';
import { useState } from 'react';

import { ParentRow } from '../parentRows';

import type { IBaseTableColumnProps } from 'components/atoms/base-table/types';
import type { Clinic } from 'infrastructure/classes/clinic';

export const useParentCols = (): Array<IBaseTableColumnProps<Clinic>> => {
  const [expandIndexes, setExpandIndexes] = useState<number[]>([]);

  const cols: Array<IBaseTableColumnProps<Clinic>> = [
    {
      label: i18next.t('labels.clinic'),
      key: 'legalname',
      onCell: () => ({
        colSpan: 6,
      }),
      render(value, data, idx) {
        const isExpanded = expandIndexes.includes(idx);
        const onExpand = () => {
          if (isExpanded) {
            setExpandIndexes(expandIndexes.filter((el) => el !== idx));
          } else {
            setExpandIndexes([...expandIndexes, idx]);
          }
        };

        return (
          <ParentRow data={data} isExpanded={isExpanded} onExpand={onExpand} />
        );
      },
    },
    {
      label: i18next.t('labels.sla'),
      key: 'serviceDeliveryThresholds',
      width: '54px',
      onCell: () => ({ colSpan: 0 }),
    },
    {
      label: i18next.t('labels.info'),
      width: '357px',
      key: 'address',
      onCell: () => ({ colSpan: 0 }),
    },
    {
      label: i18next.t('labels.providerServiceType'),
      key: 'providerServiceType',
      onCell: () => ({ colSpan: 0 }),
      width: '241px',
    },
    {
      label: i18next.t('labels.address'),
      key: 'address',
      onCell: () => ({ colSpan: 0 }),
      width: '205px',
    },
    {
      label: i18next.t('labels.status'),
      key: 'status',
      onCell: () => ({ colSpan: 0 }),
      width: '98px',
    },
  ];
  return cols;
};
